var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EnoticeError, ErrorType } from './index';
var PlacementError = /** @class */ (function (_super) {
    __extends(PlacementError, _super);
    function PlacementError() {
        var _this = _super.call(this, 'Placement Error: Error occured while placing the notice. Please try refreshing, and contact help@column.us if the problem persists.') || this;
        _this.errorType = ErrorType.PlacementError.type + "01";
        _this.errorCode = 601;
        _this.name = "" + ErrorType.PlacementError.name;
        _this.setErrorMessage();
        return _this;
    }
    return PlacementError;
}(EnoticeError));
export { PlacementError };
